// Language is initialised in ./i18n and changed by the LanguageSwitcher
export const I18nProvider = ({ children }) => children
